export default __webpack_public_path__ + "static/media/placeholder.e5c5d596.jpg";